import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SwipeableDrawer } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { GlobalState } from 'reducers/stateTypes';
import { closeNoteDrawer, openNoteDrawer } from 'reducers/contactNoteListReducer';
import { JBColors, JBTheme } from '@juliusbaer-gcrm/gcrm-frontend-components';

const useStylesContactNote = makeStyles({
  drawerPaper: {
    width: '50%',
    backgroundColor: JBColors.support.greenSmoke[10],
    paddingRight: JBTheme.spacing(6),
    boxShadow: 'none',
    whiteSpace: 'break-spaces',
  },
});

type RightDrawerProps = {
  children: React.ReactNode;
};

/**
 * An openable drawer component that takes half of the screen. Meant for Split layout.
 * @param rightDrawerProps
 * @constructor
 */
const RightDrawer = (rightDrawerProps: RightDrawerProps) => {
  const classes = useStylesContactNote();
  const noteDrawerOpen: boolean = useSelector((state: GlobalState) => state.contactNoteList.drawerOpen);
  const dispatch = useDispatch();

  return (
    <SwipeableDrawer
      anchor="right"
      open={noteDrawerOpen}
      onClose={() => dispatch(closeNoteDrawer())}
      onOpen={() => dispatch(openNoteDrawer())}
      classes={{ paper: classes.drawerPaper }}
      variant="persistent"
    >
      <div style={{ marginBottom: '100px' }}>{rightDrawerProps.children}</div>
    </SwipeableDrawer>
  );
};

export default RightDrawer;
